import Auth from '@/helpers/authorizations'
import Management from '@/layouts/Management'

export default {
  path: '/coupons',
  component: Management,
  redirect: '/coupons/list',
  children: [
    // 列表页
    {
      path: 'list',
      component: () => import('@/views/coupons/List'),
      meta: {
        auth: Auth.listCoupons
      },
      children: [
        {
          path: 'all',
          component: () => import('@/views/coupons/ListTable'),
          meta: {
            auth: Auth.listCoupons,
            tabName: 'all'
          }
        },
        {
          path: 'enabled',
          component: () => import('@/views/coupons/ListTable'),
          meta: {
            auth: Auth.listCoupons,
            tabName: 'enabled'
          }
        }
      ]
    }
  ]
}
